import { createContext, useCallback, useContext, useState, type ReactNode } from "react";

export interface ReferralShareConfig {
  /** Where the modal was opened from — used for analytics */
  source?: string;
}

interface ReferralShareContextValue {
  isOpen: boolean;
  config: ReferralShareConfig;
  openReferralShare: (config?: ReferralShareConfig) => void;
  closeReferralShare: () => void;
}

const ReferralShareContext = createContext<ReferralShareContextValue>({
  isOpen: false,
  config: {},
  openReferralShare: () => {},
  closeReferralShare: () => {},
});

export function ReferralShareProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [config, setConfig] = useState<ReferralShareConfig>({});

  const openReferralShare = useCallback((cfg?: ReferralShareConfig) => {
    setConfig(cfg ?? {});
    setIsOpen(true);
  }, []);

  const closeReferralShare = useCallback(() => {
    setIsOpen(false);
    setTimeout(() => setConfig({}), 200);
  }, []);

  return (
    <ReferralShareContext.Provider
      value={{ isOpen, config, openReferralShare, closeReferralShare }}
    >
      {children}
    </ReferralShareContext.Provider>
  );
}

export function useReferralShare() {
  return useContext(ReferralShareContext);
}
